import { render, staticRenderFns } from "./view4.vue?vue&type=template&id=7e80cd8a&scoped=true"
import script from "./view4.vue?vue&type=script&lang=js"
export * from "./view4.vue?vue&type=script&lang=js"
import style0 from "./view4.vue?vue&type=style&index=0&id=7e80cd8a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e80cd8a",
  null
  
)

export default component.exports